module.exports = __webpack_public_path__ + "images/category_lp/common/reason2-shared@2x_85c6f680924427d8ee86401ec5da33d2.jpg";